import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub}  from 'react-icons/bs'
import {BsBehance} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className='header_socials' >
      <a href="https://www.linkedin.com/in/prateek-arora-917782191/" target="_blank"><BsLinkedin /></a>
      <a href="https://github.com/prateekarora0819" target="_blank"><BsGithub /></a> 
      <a href="https://www.behance.net/prateekarora7" target="_blank"><BsBehance /></a>
    </div>
  )
}

export default HeaderSocials